import { Component } from '@angular/core'

@Component({
    selector: 'app-cookies-consent-options-modal',
    templateUrl: './cookies-consent-options-modal.component.html',
    standalone: false
})
export class CookiesConsentOptionsModalComponent { }
